var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable camelcase */
import axios from 'axios';
import { environment } from '../environments/environment';
import { LocalStorageService } from './local-storage.service';
import { BUI_PARAMETROS_CHAVES, PARA_GRUPO_ID, SUBDOMINIO_PADRAO } from '../constants/client_data';
var ClientService = /** @class */ (function () {
    function ClientService() {
        this.clientData = [];
        this.parametrosChaves = BUI_PARAMETROS_CHAVES;
        this.localStorage = LocalStorageService.singleton();
        this.axios = axios.create({
            baseURL: environment.builds.back
        });
    }
    ClientService.singleton = function () {
        if (!ClientService.clientService) {
            ClientService.clientService = new ClientService();
        }
        return ClientService.clientService;
    };
    ClientService.prototype.init = function () {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var params, response, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        this.subdomain = this.getSubdominioUrl();
                        // Altere os valores abaixo para testar localmente
                        if (window.location.hostname.includes('localhost') || window.location.hostname === 'localhost') {
                            this.subdomain = SUBDOMINIO_PADRAO;
                        }
                        params = {
                            ambi_id: environment.ambiente,
                            para_grupo_id: PARA_GRUPO_ID,
                            ambi_tipo_id: environment.ambi_tipo_id,
                            subdomain: this.subdomain
                        };
                        return [4 /*yield*/, this.axios.get('/builds/parametros_publicos', { params: params })];
                    case 1:
                        response = _b.sent();
                        if (!((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data.length)) {
                            console.error('Não foi possível carregar os dados do cliente');
                            return [2 /*return*/, 404];
                        }
                        this.clientData = response.data.data;
                        return [2 /*return*/, response.status];
                    case 2:
                        error_1 = _b.sent();
                        console.error(error_1);
                        this.clientData = [];
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ClientService.prototype.getSubdominioUrl = function () {
        var plataformaUrls = environment.pluriConnect.front;
        var windowLocationOrigin = window.location.origin;
        if (plataformaUrls.includes(windowLocationOrigin)) {
            return SUBDOMINIO_PADRAO;
        }
        var hostName = windowLocationOrigin.replace(/(^\w+:|^)\/\//, '');
        var partes = hostName.split('.');
        return partes.shift();
    };
    ClientService.prototype.getClientDataByKey = function (chave) {
        var _a;
        return ((_a = this.clientData.find(function (item) { return item.para_chave === chave; })) === null || _a === void 0 ? void 0 : _a.para_valor) || '';
    };
    ClientService.prototype.subdomainIsValid = function () {
        return this.clientData.length > 0;
    };
    ClientService.prototype.getClientDataByArrayKey = function (key) {
        var _this = this;
        var dataObject = {};
        key.forEach(function (item) {
            dataObject[item] = _this.getClientDataByKey(item);
        });
        return dataObject;
    };
    ClientService.prototype.getClientLogoUrl = function () {
        return this.getClientDataByKey(this.parametrosChaves.logoUrl);
    };
    ClientService.prototype.getClientName = function () {
        return this.getClientDataByKey(this.parametrosChaves.clientName);
    };
    ClientService.prototype.getClientDocs = function () {
        var policy = environment.builds.back + '/builds/documento/politica_privacidade/' + this.subdomain;
        var terms = environment.builds.back + '/builds/documento/termos_uso/' + this.subdomain;
        return { policy: policy, terms: terms };
    };
    return ClientService;
}());
export { ClientService };
